
module.exports = {"attributes":{"width":"10","height":"24","viewBox":"0 0 10 24","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M1.80892 23.588L0.191918 22.412L7.76392 12L0.190918 1.58799L1.80792 0.411987L9.80792 11.412C10.0629 11.763 10.0629 12.237 9.80792 12.588L1.80892 23.588Z\"/>"}
var desvg = require('@kossnocorp/desvg/preact')
module.exports = desvg(module.exports)
